<template>
    <div class="bg-light">
        <div class="d-flex justify-content-center align-items-center gap-4 mb-8">
            <div class="d-flex align-items-center gap-2 text-gray-500">
                <div class="bg-dark rounded-circle d-flex justify-content-center align-items-center text-white" style="width: 32px; height: 32px;">1</div>
                Datos de viaje
            </div>
            <div class="flex-grow-1 bg-gray-200" style="height: 1px;"></div>
            <div class="d-flex align-items-center gap-2 text-gray-500">
                <div class="bg-dark rounded-circle d-flex justify-content-center align-items-center text-white" style="width: 32px; height: 32px;">2</div>
                Cotizador
            </div>
            <div class="flex-grow-1 bg-gray-200" style="height: 1px;"></div>
            <div class="d-flex align-items-center gap-2 text-gray-500">
                <div class="bg-dark rounded-circle d-flex justify-content-center align-items-center text-white" style="width: 32px; height: 32px;">3</div>
                Comprar
            </div>
            <div class="flex-grow-1 bg-gray-200" style="height: 1px;"></div>
            <div class="d-flex align-items-center gap-2 text-gray-500">
                <div class="bg-dark rounded-circle d-flex justify-content-center align-items-center text-white" style="width: 32px; height: 32px;">4</div>
                Finalizar
            </div>
        </div>
        <div class="row row-cols-1 row-cols-sm-3 gap-4">
            <div class="col bg-white rounded-lg shadow-sm">
                <div alt="Viajes cortos" class="rounded-top w-100" style="object-fit: cover; background-color: dimgray; height: 210px;"></div>
                <div class="p-4">
                    <h3 class="text-xl font-weight-bold mb-2">Viajes cortos</h3>
                </div>
            </div>
        </div>

    </div>
</template>
  
<script>
  // import axios from 'axios';
    export default {
        name: 'HelloWorld',
        url: 'http://zebraasistencia.page/api/v1/',
        props: {
            msg: String
        },
        mounted() {
            this.getContries();
        },
        methods: {
        getContries() {
            // let self = this;
        },
        },
    }
</script>

  